<div class="col-12">
  <div class="col-12 px-0 text-center">
    <img class="img-fluid" src="assets/logout.png" alt="Logged out page image">
    <div>
      <label class="col-md-8 successMsg font-weight-bolder pt-3"> You have successfully logged out</label>
      <br> <label class="col-md-6 loginGain font-weight-bolder pt-3">To log in to this site again, click
        below.</label>
      <div class="col-12"><button class="col-3 col-md-2 col-sm-2 btn btn-block text-center my-3 cape-login-btn"
          (click)="goToLogin()">Log in</button></div>
    </div>
  </div>
</div>
